const BidderTypes = Object.freeze({
  ADVANCER: 1,
  OPENER: 2,
  OVERCALLER: 3,
  RESPONDER: 4,
});

export { BidderTypes };
